var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "dialogRoot",
      staticClass: "selectFolderDialogRoot",
      attrs: {
        role: "dialog",
        "aria-labelledby": "textInputMsgTitle",
        "aria-describedby": "textInputMsg"
      }
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "dialogBody" },
        [
          _c("FolderBrowser", {
            ref: "folderBrowser",
            attrs: {
              projectName: _vm.projectName,
              selectedFolderId: _vm.currentSelectedFolderId,
              isDialog: _vm.isDialog,
              dialogAllowsAllFolders: _vm.dialogAllowsAllFolders
            },
            on: { select: _vm.onFolderSelect }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "buttons" }, [
        _c(
          "div",
          {
            staticClass: "dialogButton okButton",
            attrs: { tabindex: "0" },
            on: {
              click: _vm.okClicked,
              keydown: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "space", 32, $event.key, [
                    " ",
                    "Spacebar"
                  ]) &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                $event.preventDefault()
                return _vm.okClicked($event)
              }
            }
          },
          [_vm._v("\n\t\t\tOK\n\t\t")]
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titleBar" }, [
      _c(
        "div",
        {
          staticClass: "title",
          attrs: { id: "textInputMsgTitle", role: "alert" }
        },
        [_vm._v("Select a Folder")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }